var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 51.833H39.667C46.667 51.833 51.3337 47.1663 51.3337 40.1663V28.4997C51.3337 22.1997 47.367 17.533 41.5337 16.833C41.067 16.833 40.367 16.833 39.667 16.833H16.3337C15.6337 16.833 15.167 16.833 14.467 17.0663C8.40032 17.7663 4.66699 22.1997 4.66699 28.4997C4.66699 29.1997 4.66699 30.133 4.66699 30.833",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5335 16.8331C41.0668 16.8331 40.3668 16.8331 39.6668 16.8331H16.3335C15.6335 16.8331 15.1668 16.8331 14.4668 17.0664C14.7001 16.3664 15.1668 15.8998 15.8668 15.1998L23.3335 7.4998C26.6001 4.23314 31.7335 4.23314 35.0001 7.4998L39.2001 11.6998C40.6001 13.0998 41.3001 14.9665 41.5335 16.8331Z",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3337 29.667H44.3337C41.767 29.667 39.667 31.767 39.667 34.3337C39.667 36.9003 41.767 39.0003 44.3337 39.0003H51.3337",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.537 50.4334C17.667 50.4334 21.0036 47.0967 21.0036 42.9667C21.0036 38.8367 17.667 35.5 13.537 35.5C9.40699 35.5 6.07031 38.8367 6.07031 42.9667C6.07031 47.0967 9.40699 50.4334 13.537 50.4334Z",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 51.8333L7.00033 49.5",
    stroke: "#FF8C69",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.97e9e1da.svg";
export { ForwardRef as ReactComponent };